import React from 'react'
import Moment from 'moment'

import CompDatePicker from 'components_new/atoms/DatePicker'

import 'moment/locale/sv'

// Local files.
import Styles from './styles.module.css'

const DatePicker = ({
  value,
  onChange,
  label,
  labelBackground,
  size = 'large'
}) => {
  const parsedValue = typeof value === 'string' ? Moment(value) : value

  return (
    <div className={label ? Styles['label-container'] : ''}>
      {label && (
        <label className={labelBackground ? Styles['colored-label'] : ''}>
          {label}
        </label>
      )}
      <CompDatePicker
        size={size}
        views={['year', 'month', 'day']}
        minDate="0001-01-01"
        maxDate="2500-12-31"
        value={parsedValue}
        onChange={(newValue) => onChange(newValue)}
        clearable={false}
        placeholder={'Välj datum'}
      />
    </div>
  )
}

export default DatePicker
